import React from 'react';

const colorMap = {
  CRITICAL: 'sev-critical',
  HIGH: 'sev-high',
  MEDIUM: 'sev-medium',
  LOW: 'sev-low',
  PASS: 'sev-pass',
};

export const SeverityBadge = ({ severity, count, className = '' }) => {
  const cls = colorMap[severity?.toUpperCase()] || 'sev-low';
  return (
    <span
      data-testid={`severity-badge-${severity?.toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest px-2 py-1 border ${cls} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: 'currentColor' }} />
      {severity}
      {count !== undefined && <span className="font-semibold">{count}</span>}
    </span>
  );
};

export const StageBadge = ({ stage }) => {
  const map = {
    draft_gazette: { label: 'Draft Gazette', cls: 'sev-low' },
    public_consultation: { label: 'Public Consultation', cls: 'sev-medium' },
    final_published: { label: 'Final Published', cls: 'sev-pass' },
    enforcement: { label: 'Enforcement', cls: 'sev-high' },
  };
  const s = map[stage] || { label: stage, cls: 'sev-low' };
  return (
    <span className={`inline-flex items-center font-mono text-[10px] uppercase tracking-widest px-2 py-1 border ${s.cls}`}>
      {s.label}
    </span>
  );
};
